import { App, Modal } from "antd";
import lodash from "lodash";
import numeral from "numeral";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  cloudSaveDraftDialog,
  deleteTimelineSpeaker,
  reColorTimelineSpeaker,
  reNameTimelineSpeaker,
  setDraftDialogAdvanceSave,
  setDraftDialogOpenAdvance,
  setDraftDialogSpeakerColor,
  setDraftDialogSpeakerName,
  splitTimelineAction,
} from "store/bailiff/draft/dialog/draft_dialog.action";
import {
  draftDialogAdvanceSave,
  draftDialogAdvanceSelected,
  draftDialogDetailSelector,
  draftDialogSecondSelector,
  draftDialogSpeakerColor,
  draftDialogSpeakerName,
} from "store/bailiff/draft/dialog/draft_dialog.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str

export const useActionDialogAdvance = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleConfirm = ({ origin, id }) => {
    if (!origin || !id) return;
    Modal.confirm({
      title: "Warning",
      centered: true,
      content: "Bạn có chắc chắn là sẽ xoá Speaker này?",
      onOk: () => {
        console.log("OK");
        handleRemove({ origin, id });
      },
      onCancel: () => {
        console.log("Cancel");
      },
    });
  };

  const handleRemove = ({ origin, id }) => {
    dispatch(deleteTimelineSpeaker({ origin, id }));
  };

  const handleConfirmCloseAdvance = () => {
    Modal.confirm({
      title: "Đóng hộp thoại",
      centered: true,
      content:
        "tất cả tiến trình bạn xử lý sẽ bị hủy bỏ sau khi bạn đóng hộp thoại, Bạn có chắc chắn là muốn đóng hộp thoại không?",
      onOk: () => {
        console.log("OK");
        handleCancel();
      },
      onCancel: () => {
        console.log("Cancel");
      },
    });
  };

  const handleCancel = () => {
    dispatch(setDraftDialogOpenAdvance(false));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { handleConfirm, handleConfirmCloseAdvance };
};

//
export const useActionDialogSpeakerColor = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const data = useSelector(draftDialogSpeakerColor);
  // -------------------------- FUNCTION ------------------------
  const handleOpen = (origin, id) => {
    if (!origin || !id) return;
    const data = { origin, id };
    dispatch(setDraftDialogSpeakerColor(data));
  };

  const handleCancel = () => {
    dispatch(setDraftDialogSpeakerColor(null));
  };

  const handleSave = ({ bgColor, color }) => {
    const { origin, id } = data;
    console.log({ origin, id, bgColor, color });
    if (!origin || !id) return;
    if (!bgColor || !color) return message.error("Vui lòng chọn màu!");
    dispatch(reColorTimelineSpeaker({ origin, id, bgColor, color }));
    handleCancel();
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { handleOpen, handleCancel, handleSave };
};

// change speaker name
export const useActionDialogSpeakerName = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const data = useSelector(draftDialogSpeakerName);
  // -------------------------- FUNCTION ------------------------
  const handleOpen = (origin, id) => {
    if (!origin || !id) return;
    const data = { origin, id };
    dispatch(setDraftDialogSpeakerName(data));
  };

  const handleCancel = () => {
    dispatch(setDraftDialogSpeakerName(null));
  };

  const handleSave = ({ name }) => {
    const { origin, id } = data;
    if (!origin || !id) return;
    if (!name) return message.error("Vui lòng nhập tên Speaker!");
    dispatch(reNameTimelineSpeaker({ origin, id, name }));
    handleCancel();
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { handleOpen, handleCancel, handleSave };
};

// split action
export const useActionDialogSplitAction = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const second = useSelector(draftDialogSecondSelector);
  const id = useSelector(draftDialogAdvanceSelected);

  // -------------------------- FUNCTION ------------------------
  const handleSplit = (origin) => {
    console.log({ origin, id, second });
    if (!origin || !id || !second) return;
    dispatch(splitTimelineAction({ origin, id, second }));
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { handleSplit };
};

// advance save
export const useActionDialogAdvanceSave = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const data = useSelector(draftDialogAdvanceSave);
  const initData = useSelector(draftDialogDetailSelector);
  // -------------------------- FUNCTION ------------------------
  const handleOpen = (origin) => {
    if (!origin) return;
    dispatch(setDraftDialogAdvanceSave(origin));
  };

  const handleCancel = () => {
    dispatch(setDraftDialogAdvanceSave(null));
  };

  const handleSave = () => {
    if (!data) return message.error("Dữ liệu Save không tìm thấy!");
    setLoading(true);
    const init = lodash.cloneDeep(initData);
    const id = init?.id;
    const sentences = init?.sentences || [];
    const inserts = init?.inserts || [];
    const senSlot = sentences?.map((s) => s?.slot) || [];
    const insSlot = inserts?.map((i) => i?.slot) || [];
    const { CAU, removeSen, removeIns } = refineData({
      data,
      senSlot,
      insSlot,
    });

    dispatch(
      cloudSaveDraftDialog(
        { id, CAU, rSens: removeSen, rIns: removeIns },
        (res) => {
          setLoading(false);
          if (res?.status === 200) {
            message.success("Lưu file hoàn tất!");
            handleCancel();
          }
          if (res?.status === 500) {
            message.error(res?.data);
          }
        },
      ),
    );
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { loading, handleOpen, handleCancel, handleSave };
};

// remap data to officialData
const refineData = ({ data, senSlot, insSlot }) => {
  const CAU = [];

  let result = lodash.cloneDeep(data);
  let num = 1;
  let keepSlot = 1;
  result?.forEach((r) => {
    const speaker = r?.name || r?.id || "";
    const actions = r?.actions || [];
    actions?.forEach((ac) => {
      const start = ac?.start;
      const end = ac?.end;
      const text = ac?.content;
      let slot = ac?.slot || "none";
      // rẽ nhánh ở khúc này.
      // TH1. nếu inslot có mà slot không có.
      let action = "";
      let source = "";

      const checkInsSlot = insSlot?.includes(slot);
      if (checkInsSlot) {
        action = "update";
        source = "insert";
      }

      const checkSenSlot = senSlot?.includes(slot);
      if (checkSenSlot) {
        action = "update";
        source = "sentence";
      }

      if (slot === "none") {
        action = "create";
        source = "insert";
        slot = keepSlot + "." + numeral(num).format("00");
        slot = parseFloat(slot);
        num++;
      } else {
        keepSlot = ac.slot;
      }

      const object = {
        start,
        end,
        text,
        speaker,
        slot,
        action,
        source,
      };
      CAU.push(object);
    });
  });

  const remapSlot = CAU?.map((f) => f?.slot) || [];
  // kiểm tra xoá sen
  const removeSen = lodash.difference(senSlot, remapSlot) || [];

  // kiểm tra xoá inserts
  const removeIns = lodash.difference(insSlot, remapSlot) || [];

  return { CAU, removeSen, removeIns };
};
